import { memo } from 'react';
import {
  WidgetContainer,
  Grid,
  TypographyWithHelp,
  S6,
  Typography,
  useTranslations,
} from '@uniqkey-frontend/shared-app';

interface IDashboardServicesNoDataWidgetProps {
  tooltipTranslationKey: string;
  titleTranslationKey: string;
  noDataTranslationKey: string;
}

const DashboardServicesNoDataWidget = (props: IDashboardServicesNoDataWidgetProps) => {
  const { tooltipTranslationKey, titleTranslationKey, noDataTranslationKey } = props;
  const { t } = useTranslations();

  return (
    <WidgetContainer container withShadow minHeight={270}>
      <Grid container alignContent="space-between" justifyContent="center">
        <Grid item>
          <TypographyWithHelp
            helperText={t(tooltipTranslationKey)}
            color={S6}
          >
            {t(titleTranslationKey)}
          </TypographyWithHelp>
        </Grid>
        <Grid item container justifyContent="center">
          <Typography>
            {t(noDataTranslationKey)}
          </Typography>
        </Grid>
        <Grid item container />
      </Grid>
    </WidgetContainer>
  );
};

export default memo(DashboardServicesNoDataWidget);
